import React from 'react';
import style from './FsBuildTop.module.css';
import ReactDOM from 'react-dom';
import { Button,IconFont } from '@jd/find-react';
import { Menu, Dropdown,  message, Tooltip } from '@jd/find-react';
 

import KeeVue from '../base/KeeVue.js'
import FsDropdown from '../element/FsDropdown.js'

 

import $ from 'jquery';




 export default class FsBuildTop extends KeeVue {
   constructor(props) {
          super(props);

		 // this.showHelpInfo = this.showHelpInfo.bind(this);
		  // this.myRef = React.createRef();
		  let that= this;




 			this.state =  {
 				randId: this.getRandString(),
 				isKeeShowBorder: false,
 				showSource: false,
 				configWindow: null,
 				appId: window.appId,
 				jdccApp: {title:'','name':'dsss'},
 				currentScale:"100%",
				isSaving:false,
				xietongUser:"",
				dropdownComponent:{
					cp:{
						menuJson:JSON.stringify( [{
            				code: 'daochu',
            				title: '导出'
            			}, 
            			{
            				code: 'daoru',
            				title: '导入'
            			},
            			{
            				code: 'bangzhu',
            				title: '帮助'
            			} 
            			]),
						type:"text",
						title:"更多"
					},
					style:{
						"display":"inline-block"
					}
				}
 			};

 }

 componentDidMount(){
 			let that = this;
			// setTimeout(function(){
			// 			  that.bindThis(that);
			// },10);

			this.registComponent();

 			if(  this.isNotBlank(this.state.appId)) {
 				this.doRequest("/jdccApp/get?id=" + this.state.appId, function(jdccApp) {
					
					window.currentAppInfo = jdccApp;
					
					if(jdccApp.map&&jdccApp.map.resFileList)
					{
						jdccApp.map.resFileList = JSON.parse(jdccApp.map.resFileList);
					}

					console.log(JSON.stringify(jdccApp));

					 that.setState({
					 	jdccApp:jdccApp
					 });
					// that.render();
 				})
 			}


 			this.onEvent("key.format", this.formatJavascript);
 			this.onEvent("key.q", this.viewChange);
 			this.onEvent("currentScaleValue",(ret)=>{
 				this.state.currentScale = ret+"%";
				this.refresh()
 			})
 			this.onEvent("pageSaved",(app)=>{
				this.state.isSaving=false;
				if(window.$loading)
				{
					window.$loading.close();
				}
				
				
				if(app)
				{
					this.state.jdccApp.version = app.version; 
				}
				else
				{
					this.doRequest("/jdccApp/get?id=" + this.state.appId, function(jdccApp) {
						this.state.jdccApp.version = jdccApp.version;
						this.refresh();
					})
				}
				
				this.refresh();
				
 				
 			})
			
			this.onEvent("xietongUsers",(msg)=>{
				this.state.xietongUser = msg; 
				this.refresh();
			})
			 
 		}

 			viewChange=()=> {
 				this.controller.showSource = !this.controller.showSource;
 				window.editor.setValue(this.keePage.vueSource);
 				window.editor.clearSelection();
 			}
 			openTemplateDlg=()=> {
 			}
 			zoomOut=()=>
 			{
				this.props.controller.showCenterPage = "huabu";
 				this.sendEvent("zoomOut");
 			}
 			zoomIn=()=>
 			{
				this.props.controller.showCenterPage = "huabu";
 				this.sendEvent("zoomIn");
 			}
 			copyComponent=()=> {
 				this.sendEvent("copyComponent")
 			}
 			cutComponent=()=> {
 				this.sendEvent("cutComponent")
 			}
 			pasteComponent=()=> {
 				this.sendEvent("pasteComponent")
 			}
			deleteComponent=()=>{
				this.sendEvent("deleteComponent");
			}
 			testDebug=()=> {
 			}
 			showKeeBorder=(e)=> {
				
				this.props.controller.showCenterPage = "huabu";
				
				e.target.blur();
 				 
				this.state.isKeeShowBorder = !this.state.isKeeShowBorder;
								window.quanjuShowBorder= this.state.isKeeShowBorder
								this.showKeeBorderState(this.props.components, this.state.isKeeShowBorder);
								this.sendEvent("changeShowBorder",this.state.isKeeShowBorder);
								this.refresh()
								
 			}
 			showKeeBorderState=(componentArray, state)=> {
 				if(componentArray != null) {
 					for(let i = 0; i < componentArray.length; i++) {
 						componentArray[i].isKeeShowBorder = state;
 						this.showKeeBorderState(componentArray[i].child, state);
 					}
 				}
 			}
 			formatJavascript=()=> {
				this.props.controller.showCenterPage = "source";
 				let js_source = window.editor.getValue();
 				// let fjs = window.js_beautify(js_source, 1, "\t");
				let fjs = window.js_format_beautify(js_source, {});
				
				
				
				fjs = fjs.replaceAll("= >","=>");
 				window.editor.setValue(fjs);
 				window.editor.clearSelection();
 			}
			
			
			
 			previewComponent=()=> {
				
				// 先把数据存入到
				
				let previewPageCode = "preview2";
				
				let htmlPage="show.html";
				
				if(this.state.jdccApp.clientType=='APPSITE')
				{
					previewPageCode = "previewH5";
					htmlPage = "showH5.html";
				}
				
				 
				
				let previewUrl=window.rootWebPath+"/"+htmlPage+"?";
				previewUrl+="sp=2018_M::"+this.state.jdccApp.name+"/"+this.props.keePage.code;
				previewUrl+="&tid="+window.tid;
				previewUrl+="&clientType=PC";
				previewUrl+="&keyName="+window.keyName;
				
				previewUrl+="&pageCode="+this.props.keePage.code;
				previewUrl+="&appName="+this.state.jdccApp.name;
				previewUrl+="&from=short";
				
				previewUrl+="&jzhhid="+window.jzhhid;
				
				previewUrl+="&isPreview=true";
							
				let appId = this.state.jdccApp.id+window.KeeUtils.getRandString();
				previewUrl+="&appId="+appId;
			
							 
			 
				this.openBottomPage("M::jdccApp/"+previewPageCode+"&id=",{
					
					page:"M::"+this.state.jdccApp.name+"/"+this.props.keePage.code, 
					previewUrl:previewUrl, 
					height:"95%",
					withHeader:true,
					title:"预览页面："+this.props.keePage.code,
					appCode:this.state.jdccApp.name
					
				});
				
				// 同时要把预览数据更新到服务器，用户可扫码进行预览
				 
				//this.sendEvent("top.preview",this.props.keePage.code,this.props.controller.showReact,appId);
					 
				return ;
				
				
				/*	
 				if(this.state.jdccApp.clientType=="APPSITE")
 				{
 					let previewUrl = (window.webUrl+"/appShow/"+this.state.jdccApp.name+"/"+this.keePage.code+"?previewUrl="+window.webUrl+"&tid="+window.tid);
 					this.openDlgPage("M::jdccApp/showPreviewBarcode"  , {
 					title: '扫码预览',
 					size: 'normal',
 					width: '45%',
 					top: "10vh",
 					loadUrl: '/jdccApp/get?id=' ,
 					previewUrl:previewUrl,
 					extraParas: {
 					},
 					onChanged(ret, form) {
 						}
 					})
 				}
 				else
 				{
				
					this.sendEvent("top.preview",this.props.keePage.code,this.props.controller.showReact)
					
				//	this.state.configWindow = window.open(("/index.html?tid=" + window.tid  + "&keyName="+window.keyName+"&pageCode=" + this.props.keePage.code+"&appName="+window.appName +"#preview"), window.appName + "预览");
					
				}*/
 			}
 			showHelpInfo=()=> {
				window.open("https://joyspace.jd.com/teams/6lsrV9Dv4OQYTexBBVja0", "系统帮助");
				
 				//window.open(("http://cpaas.dev.xjoycity.com/front/help/index.jsp?tid="+window.tid), "系统帮助");
 
 			}
 			saveComponent=(evt)=> {
				this.state.isSaving = true;
				this.refresh();
				window.$loading = window.mainVueApp.$loading({
				                    lock: true,
				                    text: '正在保存数据中...',
				                    spinner: 'el-icon-loading',
				                    background: 'rgba(0, 0, 0, 0.6)'
				                });
								
 				this.sendEvent("top.save");
 			}
 			publishApp=()=> {
 				this.sendEvent("top.publishApp");
 			}
 			showComponentSource=()=>{
 				this.sendEvent("top.componentSource")
 			}
 			showComponentList=()=>{
 				this.openBottomPage("M::jdcc.vueComponent/list&id=",{});
 			}
 			showDataModelList=()=>{
 				this.openBottomPage("M::adminDbModel/tableList&id=",{});
 			}
			
			showComponentJsonPage=()=> { 
				this.props.controller.showCenterPage = "huabu";
				  this.sendEvent("showComponentJsonPage"); 
			}
			
			showAppCssPage=()=>{
				if(window.currentAppInfo)
				{
					if(!window.currentAppInfo.map.appPageCss)
					{
						window.currentAppInfo.map.appPageCss="";
					}
					
					let appPageCss =  window.currentAppInfo.map.appPageCss;
					
					this.openDlgPage("M::icMaterial/appCssPage&id=", {
						title:  '应用css代码配置',
						size: '800',
						 
						top: "10vh",
						loadUrl: '/keeVueComponent/get?id=',
						po: {
							appPageCss:appPageCss
						},
					 
						cb(ret, form) { 
							window.currentAppInfo.map.appPageCss = ret;
							form.$emit("command", "close");
						}
					})
				}
				else
				{
					alert("error");
				}
			}
			
			handleMenuClick=(e)=>{
				console.log(e);
				switch(e.key)
				{
					case 'bangzhu': this.showHelpInfo();break;
					case 'daochu':	this.sendEvent("exportApp");break;
					case 'daoru' :this.sendEvent("importApp");break; 
					case 'sucai' :this.sendEvent("sucaiManage");break;
					case 'outResFile' :this.sendEvent("outResFileClick");break;
					
					case 'jsonData' :this.showComponentJsonPage( );break;
				}
				 
			    
			}

   render(){
	   
	   let menu=(<Menu onClick={this.handleMenuClick}>
	   {
	   	[{
	   		code: 'daochu',
	   		title: '导出'
	   	}, 
	   	{
	   		code: 'daoru',
	   		title: '导入'
	   	},
		{
			code: 'jsonData',
			title: 'JSON数据'
		},
		
		{
			code: 'sucai',
			title: '素材管理'
		},
		{
			code: 'outResFile',
			title: '外部资源'
		},
	   	{
	   		code: 'bangzhu',
	   		title: '帮助'
	   	} 
	   	].map((item,index)=>{
	   		return <Menu.Item key={item.code}  >
	   		  {item.title}
	   		</Menu.Item>
	   	})
	   } 
	   </Menu>)
	   
   return(

 <div  style={{textAlign:'center'}} id={this.state.randId} >
     <div style={{float:' left',marginLeft:' 10px',marginTop:'0px'  }} >
         <div style={{ width:' 40px',lineHeight:' 54px',fontSize:' 30px',float:' left', textAlign:' center'}} >
            
         </div>
         <div style={{ height:'40px',lineHeight:' 54px',fontSize:' 18px', float:' left', textAlign:' left',marginLeft:' 10px'}} >

 				{this.state.jdccApp!=null?this.state.jdccApp.title :'&nbsp;'}{this.state.jdccApp!=null?'('+this.state.jdccApp.name+')' :'&nbsp;'}

             <span style={{fontSize:'14px',color:'#888'}} >
             {this.state.jdccApp!=null?'V'+this.state.jdccApp.version+'' :'&nbsp;'}
             </span>
			 
			 <span style={{fontSize:'14px',color:'#888',marginLeft:'20px'}} >
			 {this.state.xietongUser?this.state.xietongUser :'1人在编辑'}
			 </span>
			 
			 
         </div>
     </div>
     <div className={`jdcc-disable-select top-btns`} style={{ float:' right',marginRight:' 0px', marginTop:' 2px'}} >
         
		 <Button type="info"   onClick={()=>{this.sendEvent("huanyuan")}} >
		     <div >
		         <i className={`iconfont icon-left-square`}   >
		         </i>
		     </div>
		     <div  >
		     还原
		     </div>
		 </Button>
		 <Button type="info"   onClick={()=>{this.sendEvent("chongzuo")}} >
		     <div >
		         <i className={`iconfont icon-right-square`}   >
		         </i>
		     </div>
		     <div  >
		     重做
		     </div>
		 </Button>
		 
		 
         <Button type="info"   onClick={this.previewComponent} >
             <div >
                 <i className={`iconfont icon-play-circle`}   >
                 </i>
             </div>
             <div  >
             预览
             </div>
         </Button>
         <Button type="info"  disabled={this.state.isSaving}  onClick={this.saveComponent} >
             <div >
                 <i className={`iconfont icon-save`} >
                 </i>
             </div>
             <div >
             保存
             </div>
         </Button>
		 {
			 window.ClientInsConfig&&!window.ClientInsConfig.disablePublish&&<Button type="info"   onClick={this.publishApp} >
             <div >
                 <i className={`iconfont icon-send`} >
                 </i>
             </div>
             <div >
             存档
             </div>
         </Button>
		 }
         
		 
		 <Dropdown overlay={menu}> 
			 <Button type="info"     >
			     <div >
			         <i className="iconfont icon-dash ant-dropdown-trigger ant-dropdown-open" >
			         </i>
			     </div>
			     <div >
			     更多
			     </div>
			 </Button> 
		 </Dropdown>
		  
		 
         
     </div>
     <div style={{margin:'0 auto',display:'inline-block',verticalAlign:'top',paddingTop:'4px',height:'50px'}} className={`jdcc-disable-select  top-btns`} >
          <div style={{ display:'inline-block',paddingTop:'8px','float':'left',marginLeft:'-190px'}} >
		 <Button  shape="circle" onClick={this.zoomOut} style={{ verticalAlign:'middle'}} >
             <i className={`iconfont icon-minus-circle`} >
             </i>
         </Button>
         <div style={{width:'34px',display:'inline-block',verticalAlign:'middle'}} >
         {this.state.currentScale}
         </div>
         <Button  shape="circle" onClick={this.zoomIn} style={{ verticalAlign:'middle'}} >
             <i className={`iconfont icon-plus-circle `} >
             </i>
         </Button>
		 </div>
		 <div className={`jdcc-disable-select  top-btns-center`} style={{marginTop:'-2px',display:'inline-block',marginLeft:'00px','float':'left'}} >
		     <Button type="info"   onClick={this.copyComponent} >
		         <div >
		             <i className={`el-icon-document-copy`} >
		             </i>
		         </div>
		         <div >
		         复制
		         </div>
		     </Button>
		    
		     <Button type="info"   onClick={this.pasteComponent} >
		         <div >
		             <i className={`el-icon-magic-stick`} >
		             </i>
		         </div>
		         <div >
		         粘贴
		         </div>
		     </Button>
			 <Button type="info"   onClick={this.deleteComponent} >
			     <div >
			         <i className={`el-icon-delete`} >
			         </i>
			     </div>
			     <div >
			     删除
			     </div>
			 </Button>
		     <Button type="info"   onClick={this.showKeeBorder} >
		         <div >
		             <i className={`el-icon-full-screen`} >
		             </i>
		         </div>
		         <div >
		         {this.state.isKeeShowBorder==false?'显示边框':'隐藏边框'}
		         </div>
		     </Button>
		     <Button type="info"   onClick={this.formatJavascript} >
		         <div >
		             <i className={`el-icon-tickets`} >
		             </i>
		         </div>
		         <div >
		         格式化
		         </div>
		     </Button>
			 
		 
			 {
				 /**
				  * <Button type="info"   onClick={()=>{this.props.controller.showSource = !this.props.controller.showSource;
			 this.sendEvent("showVueSource",this.props.controller.showSource);this.refresh()}} >
			     <div >
			         <i className={  `${this.props.controller.showSource!=true?'fa fa-code':'fa fa-credit-card'}`} >
			         </i>
			     </div>
			     <div >
			     {this.props.controller.showSource!=true?'源码':'界面'}
			     </div>
			 </Button>
				  */
			 }
			 
			  
			 
			 <Button type="info"     onClick={this.showAppCssPage } > <div >
		             <i className={`el-icon-setting`} >
		             </i>
		         </div>
		         <div >
		         CSS
		         </div>
			 </Button>
			 
			 <Button type="info"     onClick={this.showComponentSource} > <div >
			        <IconFont type="iconcode-Lined" style={{fontSize:'20px'}} />
			     </div>
			     <div >
			     组件源码
			     </div>
			 </Button>
			 
			 
		  
			{/*
				<Button type="info"   onClick={()=>{this.props.controller.showReact = !this.props.controller.showReact;
				this.props.controller.showCenterPage="huabu";
				this.sendEvent("showReact",this.props.controller.showReact);this.refresh()}} >
				    <div >
				        <i className={  `${this.props.controller.showReact!=true?'fa fa-vimeo':'fa fa-registered'}`} >
				        </i>
				    </div>
				    <div style={{width:'50px'}} >
				    {this.props.controller.showReact!=true?'Vue':'React'}
				    </div>
				</Button>*/
			}
			
			
			
			
			 
		 </div>
     </div>
    
 </div>
   );}
  }
